import { render, staticRenderFns } from "./AppInformacje.vue?vue&type=template&id=bc785698&"
import script from "./AppInformacje.vue?vue&type=script&lang=js&"
export * from "./AppInformacje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports